<template>
  <div style="width: 100%" class="echart">
    <div :id="main" style="width: 90%; height: 100%"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "com-echarts",
  props: {
    radius: {
      typeof: Object,
      default: function () {
        return ["0%", "70%"];
      },
    },
    seriesDate: {
      typeof: Array,
      default: function () {
        return [];
      },
    },
    main: {
      typeof: String,
      default: function () {
        return "main";
      },
    },
    color: {
      typeof: Array,
      default: function () {
        return ["#6699FF", "#A1E6CE", "#52CCA3", "#B3CDFF", "#7D8FB3"];
      },
    },
    xAxisDate: {
      typeof: Array,
      default: function () {
        return [];
      },
    },
    //bar柱状 pie扇形 line折线
    type: {
      type: String,
      default: "pie",
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      myChart: "",
      list: [],
      pieData: {
        color: [
          "#5EADFF",
          "#6699FF",
          "#A5D1FF",
          "#50D0A4",
          "#66E7BC",
          "#FFA43F",
        ],
        tooltip: {
          trigger: "item",
          extraCssText:
            "line-height:24px;color:#333;background:#fff;box-shadow:0 0 3px rgba(0, 0, 0, 0.2)",
          formatter: function (parms) {
            let html = `${parms.name}</br><span style='font-size: 14px;color: ${parms.color};'>${parms.value}</span><span style='color: ${parms.color};
font-size: 12px;margin-left:5px'>人</span>`;
            return html;
          },
        },
        grid: {
          // 调整图表与容器距离
          left: "4%",
          right: "4%",
          containLabel: true,
        },
        legend: {
          icon: "circle",
          orient: "vertical",
          left: "55%",
          align: "left",
          top: "center",
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            rich: {
              a: {
                color: "#333",
                width: 150,
                lineHeight: 25,
              },

              b0: {
                fontSize: 25,
                color: "#5EADFF",
                padding: [0, 0, 0, 0],
              },

              b1: {
                fontSize: 25,
                color: "#6699FF",
                padding: [0, 0, 0, 0],
              },

              b2: {
                fontSize: 25,
                color: "#A5D1FF",
                padding: [0, 0, 0, 0],
              },

              b3: {
                fontSize: 25,
                color: "#50D0A4",
                padding: [0, 0, 0, 0],
              },

              c: {
                color: "#ccc",
                fontSize: 12,
                padding: [-3, 10, 0, 5],
              },
            },
          },

          formatter: (name) => {
            let num;
            let index;
            for (let i = 0; i < this.seriesDate.length; i++) {
              if (this.seriesDate[i].name == name) {
                num = this.seriesDate[i].value;
                index = i;
              }
            }
            return `{a|${name}}{b${index}|${num}}{c|人}`;
          },
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["60", "100"],
            center: ["25%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "16",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: this.seriesDate,
          },
        ],
      },
      barDate: {
        tooltip: {
          trigger: "item",
          axisPointer: {
            type: "shadow",
          },
          formatter: function (parms) {
            let html = `${parms.name}</br><span style='font-size: 14px;color: ${parms.color};'>${parms.value}</span><span style='color: ${parms.color};
font-size: 12px;margin-left:5px'>人</span>`;
            return html;
          },
        },
        title: {
          text: this.title,
          bottom: 0,
          left: "center",
        },
        xAxis: {
          type: "category",
          data: this.xAxisDate,
        },
        grid: {
          x: 80, //左
          y: 30, //上
          x2: 0,
          y2: 50, //距离下边的距离
        },
        color: this.color, //自定义饼图颜色
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: this.seriesDate,
            type: "bar",
            barWidth: "40%",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#5C88FF",
                  },
                  {
                    offset: 1,
                    color: "#5BC4FF",
                  },
                ]),
              },
            },

            // emphasis: {
            //   itemStyle: {
            //     color: "#2F4654", //hover时改变柱子颜色
            //     // shadowColor: 'rgba(102,102,102,0.50)',
            //     // shadowOffsetX: 0,
            //     // shadowOffsetY: 2,
            //     // shadowBlur: 6,
            //     borderWidth: 4,
            //     borderColor: "#2F4654",
            //     borderType: "solid",
            //   },
            // },
          },
        ],
      },
      lineDate: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        title: {
          text: this.title,
          bottom: 0,
          left: "center",
        },
        xAxis: {
          type: "category",
          data: this.xAxisDate,
        },
        color: this.color, //自定义颜色
        yAxis: {
          type: "value",
        },
        series: [
          {
            type: "line",
            data: this.seriesDate,
          },
        ],
      },
    };
  },
  mounted() {
    this.myChartdata();
    console.log(this.seriesDate);
  },
  watch: {
    seriesDate: function (val) {
      if (this.type == "pie") {
        this.myChart.clear();
        this.pieData.series[0].data = val;
        this.myChart.setOption(this.pieData, true);
      } else if (this.type == "bar") {
        console.log(this.seriesDate);
        if (this.seriesDate.length>0) {
          if (this.seriesDate[0].name == "县（区）级") {
            this.seriesDate.unshift("国家级", "省（部）级", "厅局（市）级");
          }
          if (this.seriesDate[0].name == "厅局（市）级") {
            this.seriesDate.unshift("国家级", "省（部）级");
          }
          if (this.seriesDate[0].name == "省（部）级") {
            this.seriesDate.unshift("国家级");
          }
        }

        this.myChart.clear();
        this.barDate.series[0].data = val;
        this.myChart.setOption(this.barDate, true);
      } else if (this.type == "line") {
        this.myChart.clear();
        this.lineDate.series[0].data = val;
        this.myChart.setOption(this.lineDate, true);
      }
    },
  },
  methods: {
    myChartdata() {
      this.myChart = echarts.init(document.getElementById(this.main));
      if (this.type == "pie") {
        // 指定图表的配置项和数据
        var option = this.pieData;
        // 使用刚指定的配置项和数据显示图表。
        this.myChart.setOption(this.pieData);
      } else if (this.type == "bar") {
        console.log(this.barDate);
        var option = this.barDate;
        // 使用刚指定的配置项和数据显示图表。
        this.myChart.setOption(this.barDate);
      } else if (this.type == "line") {
        var option = this.lineDate;
        // 使用刚指定的配置项和数据显示图表。
        this.myChart.setOption(this.lineDate);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.echart {
  height: 38vh;
}
</style>
